import {
  GET_RECEPTIONS,
  GET_RECEPTIONS_SUCCESS,
  GET_RECEPTIONS_FAILURE,
  GET_RECEPTION,
  GET_RECEPTION_SUCCESS,
  GET_RECEPTION_FAILURE,
  EXPORT_RECEPTION,
  EXPORT_RECEPTION_FAILURE,
  EXPORT_RECEPTION_SUCCESS
} from './receptionsActions';

const initialState = {
  currentReceptions: {
    data: [],
    numberOfReceptions: 0
  },
  currentReception: {},
  loadingReception: true,
  loadingExportReception: false,
  loading: true
};

/**
 * Réducer de la partie des receptions
 */
const receptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXPORT_RECEPTION:
      return {
        ...state,
        loadingExportReception: true
      };
    case EXPORT_RECEPTION_SUCCESS:
      return {
        ...state,
        loadingExportReception: false
      };
    case EXPORT_RECEPTION_FAILURE:
      return {
        ...state,
        loadingExportReception: false
      };
    case GET_RECEPTION:
      return {
        ...state,
        currentReception: {},
        loadingReception: true
      };
    case GET_RECEPTION_SUCCESS:
      return {
        ...state,
        currentReception: action.payload.reception,
        loadingReception: false
      };
    case GET_RECEPTION_FAILURE:
      return {
        ...state,
        loadingReception: false
      };
    case GET_RECEPTIONS:
      return {
        ...state,
        loading: true
      };
    case GET_RECEPTIONS_SUCCESS:
      return {
        ...state,
        currentReceptions: {
          ...state.currentReceptions,
          data: action.payload.receptions,
          numberOfReceptions: action.payload.total
        },
        loading: false
      };
    case GET_RECEPTIONS_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

export default receptionsReducer;
